export default __webpack_public_path__ + "static/gearsEsports-white-cc67b07c7c045b51269acef8219e0bc6.svg";